import React from 'react';
import { Box } from '@mui/material';
import LineArchiveSvg from '../../../../assets/svg-fc/LineArchiveSvg';
import LineChevronSvg from '../../../../assets/svg-fc/LineChevronSvg';
import { getArchivedRowCount } from '../../../../utils/messaging/chatListState';
import './archivedRow.scss';

interface ArchivedRowProps {
  unreadChatCount?: number | null;
  onClick: () => void;
}

const ArchivedRow: React.FC<ArchivedRowProps> = ({ unreadChatCount, onClick }) => {
  const count = getArchivedRowCount(unreadChatCount);
  return (
    <Box component="button" type="button" className="archivedRow" onClick={onClick}>
      <LineArchiveSvg size={20} />
      <span className="archivedRowLabel">Archived</span>
      {count ? <span className="archivedRowCount">{count}</span> : null}
      <span className="archivedRowChevron">
        <LineChevronSvg size={18} direction="right" />
      </span>
    </Box>
  );
};

export default ArchivedRow;
